import React from 'react';
import Layout from '../components/Layout/Layout';
import "../styles/PolicyStyles.css";

const Policy = () => {
  return (
    <Layout title={'سياسة الخصوصية - النخبة ستور'}>
      {/* Hero */}
      <div className="policy-hero">
        <img src="/images/logo2.jpeg" alt="النخبة ستور" className="policy-hero-bg" />
        <div className="policy-hero-overlay">
          <h1>سياسة الخصوصية</h1>
          <p>حماية بياناتك أولويتنا</p>
        </div>
      </div>

      <div className="container" style={{maxWidth:'800px', paddingBottom:'60px'}}>
        <div className="policy-card">
          <div className="policy-logo-center">
            <div className="premium-logo-circle" style={{margin:'0 auto'}}>
              <img src="/images/logo1.jpeg" alt="النخبة ستور" width="80" height="80" />
            </div>
          </div>

          <h3 className="policy-section-title">جمع المعلومات</h3>
          <p className="policy-section-text">
            نحن في النخبة ستور نلتزم بحماية خصوصية عملائنا. نقوم بجمع المعلومات الشخصية فقط عند الضرورة لتقديم خدماتنا بشكل أفضل. لن نشارك معلوماتك الشخصية مع أطراف ثالثة إلا بموافقتك المسبقة أو عندما يتطلب القانون ذلك.
          </p>

          <h3 className="policy-section-title">أمان البيانات</h3>
          <p className="policy-section-text">
            نستخدم تقنيات أمان متقدمة لحماية بياناتك وضمان سرية معلوماتك المالية. جميع عمليات الدفع تتم عبر بوابات دفع آمنة ومشفرة. نحن نتبع أفضل الممارسات العالمية في حماية البيانات.
          </p>

          <h3 className="policy-section-title">حقوقك</h3>
          <p className="policy-section-text">
            يحق لك الوصول إلى بياناتك الشخصية وتعديلها أو حذفها في أي وقت. كما يمكنك إلغاء الاشتراك في النشرة البريدية أو أي اتصالات تسويقية بسهولة عبر الروابط المتوفرة في رسائلنا.
          </p>

          <h3 className="policy-section-title">تحديثات السياسة</h3>
          <p className="policy-section-text">
            نحتفظ بالحق في تحديث سياسة الخصوصية هذه في أي وقت. سيتم إخطارك بأي تغييرات جوهرية عبر البريد الإلكتروني أو من خلال إشعار على موقعنا. لأي استفسارات حول سياسة الخصوصية، يرجى التواصل معنا عبر صفحة اتصل بنا.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Policy;
